import { Plus } from "components/icons/generated";

import Link, { type LinkProps } from "./index";

type LinkAddProps = Partial<Pick<LinkProps, "size" | "disabled" | "tooltip">> & {
  onClick?: () => void;
  to?: string;
  text: Required<string>;
};

const LinkAdd = ({ text, size = "small", onClick, to, disabled, tooltip }: LinkAddProps) => {
  return (
    <Link
      startIcon={Plus}
      size={size}
      onPress={onClick}
      href={to}
      disabled={disabled}
      tooltip={tooltip}
    >
      {text}
    </Link>
  );
};

LinkAdd.displayName = "DS.Link.Add";

export default LinkAdd;
